import { reactive, readonly } from "vue"

export interface ErrorDialogOptions {
  title: string
  message: string
  // When given, the dialog shows "Prøv igjen" and calls this on confirm
  retry?: () => void | Promise<void>
}

interface ErrorDialogState {
  open: boolean
  title: string
  message: string
  retry: (() => void | Promise<void>) | null
}

const state = reactive<ErrorDialogState>({ open: false, title: "", message: "", retry: null })

// One dialog for every API failure — the message changes, the shape does not
export function useErrorDialog() {
  function showError(options: ErrorDialogOptions): void {
    state.title = options.title
    state.message = options.message
    state.retry = options.retry ?? null
    state.open = true
  }

  function close(): void {
    state.open = false
    state.retry = null
  }

  async function retry(): Promise<void> {
    const fn = state.retry
    close()
    if (fn) await fn()
  }

  return { state: readonly(state), showError, close, retry }
}
